/**
 * @file QueryBuilder.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Service from './Service'
import Request from '../components/http/request'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 * QueryBuilder Management Service
 * @class
 */
class QueryBuilder extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
   // this.request = new Request({environment: 'local', tag: 'das'})
    this.request = new Request({tag: 'das'})
   // this.request = new Request({environment: 'local', tag: 'das'})
  }

  /**
   * Get File Data by JsonQuery
   *
   * @async
   * @function getDataFile
   * @param {Number} environment - Environment Id
   * @param columnTemplate
   * @param guid
   * @return  File Json
   */
  async getDataFile (environment, columnTemplate, guid) {
    return new Promise((resolve, reject) => {
      if (typeof columnTemplate === 'undefined') reject(new Error('Esperado a columnTemplate'))

      let data = {
        columns: columnTemplate
      }

      let endPoint = `/api/0.1-a/QueryBuilder/querydownload/${guid}/${environment}/json`
      this.request.post(endPoint, data, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get Expressions GRid
   *
   * @async
   * @function getDataFile
   * @param {Number} environment - Environment Id
   * @param columnTemplate
   * @param guid
   * @return  File Json
   */
  async getExpressionsGrid (environment, columnTemplate, guid) {
    return new Promise((resolve, reject) => {
      if (typeof columnTemplate === 'undefined') reject(new Error('Esperado a columnTemplate'))

      let data = {
        columns: columnTemplate
      }

      let endPoint = `/api/0.1-a/QueryBuilder/queryColumns/${guid}/${environment}/json`
      this.request.post(endPoint, data, defaultJsonHeaders)
          .then(response => resolve(response))
          .catch(() => reject)
    })
  }

  /**
   * Get column metadata
   *
   * @async
   * @function translate
   * @param {string} layerUid - Layer Uid
   * @param {string} columnName - Column name
   * @return {Promise<json>} The json with the result
   */
  async columnMetadata (layerUid, columnName) {
    return new Promise((resolve, reject) => {
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof columnName === 'undefined') reject(new Error('Esperado o nome da coluna'))
      let endPoint = `/api/0.1-a/QueryBuilder/GetAttributesFiltersOnLayerColumns/${layerUid}/${columnName}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Evaluate rule pattern
   *
   * @async
   * @function evaluate
   * @param {Object} layerUid - Layer Guid
   * @param {string} classType - Class type
   * @param {Object} pageOptions - Page options
   * @param {Object} sortOptions - Sort options
   * @return {Promise<json>} The json with the result
   */
  async evaluate (layerUid, classType = 'grid', pageOptions = {skip: 0, take: 10}, sortOptions = {
    direction: 'asc',
    sortBy: 1
  }) {
    return new Promise((resolve, reject) => {
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof classType === 'undefined') reject(new Error('Esperado o tipo de classe'))

      const endPoint = `/api/0.1-a/QueryBuilder/evaluate/${layerUid}/${classType}?skip=${pageOptions.skip}&take=${pageOptions.take}&sortBy=${sortOptions.sortBy}&direction=${sortOptions.direction}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Evaluate rule pattern
   *
   * @async
   * @function evaluate
   * @param {Object} layerUid - Layer Guid
   * @param {Object} UserTemplate Column template
   * @param {string} classType - Class type
   * @param {Object} pageOptions - Page options
   * @param {Object} sortOptions - Sort options
   * @return {Promise<json>} The json with the result
   */
  async evaluateWithUserTemplate (layerUid, UserTemplate, classType = 'grid', pageOptions = {
    skip: 0,
    take: 10
  }, sortOptions = {direction: 'asc', sortBy: 1}) {
    return new Promise((resolve, reject) => {
      if (typeof layerUid === 'undefined') reject(new Error('Esperado o identificador do layer'))
      if (typeof classType === 'undefined') reject(new Error('Esperado o tipo de classe'))

      const data = { layer: layerUid, columns: UserTemplate }
      const endPoint = `/api/0.1-a/QueryBuilder/evaluateWithUserTemplate/${layerUid}/${classType}?skip=${pageOptions.skip}&take=${pageOptions.take}&sortBy=${sortOptions.sortColumn}&direction=${sortOptions.direction}`
      this.request.post(endPoint, data, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Translate rule pattern to sql pattern
   *
   * @async
   * @function translate
   * @param {Object} rootRule - Rule json pattern
   * @return {Promise<json>} The json with the result
   */
  async translate (rootRule) {
    return new Promise((resolve, reject) => {
      if (typeof rootRule === 'undefined') reject(new Error('Esperado o objeto Rule'))
      const endPoint = `/api/0.1-a/QueryBuilder/TranslateToSql`
      this.request.post(endPoint, rootRule, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }
  /**
   * Translate rule pattern to sql pattern
   *
   * @async
   * @function translateWithTemplate
   * @param {Number} environment - Environment Id
   * @param {string} classType - Class type
   * @param {Object} rootRule - Rule json pattern
   * @return {Promise<json>} The json with the result
   */
  async translateWithTemplate (environment, classType, rootRule) {
    return new Promise((resolve, reject) => {
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof classType === 'undefined') reject(new Error('Esperado o tipo de classe'))
      if (typeof rootRule === 'undefined') reject(new Error('Esperado o objeto Rule'))

      const endPoint = `/api/0.1-a/QueryBuilder/TranslateToSqlWithTemplate/${environment}/${classType}`
      this.request.post(endPoint, rootRule, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
}

export {QueryBuilder}
